import script from "./myRoomGroupPop.vue?vue&type=script&setup=true&lang=js"
export * from "./myRoomGroupPop.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__